module.exports = __webpack_public_path__ + "static/media/field_of_imagination.b89d154c.png";